import FileSaver from 'file-saver';
import { changeDateFormate } from '../../utils/dateFormat';

const processExport = (exportData: any) => {
    const expAge = [{}];
    for (let i = 0; i < exportData.length; i++) {
        expAge.push({
            'Employee Name': `${exportData[i].employee_name}`,
            'Application Role': `${exportData[i].application_role_name}`,
            'Parent Client': `${exportData[i].parent_client_name}`,
            'Scorecard': `${exportData[i].scorecard_name}`,
            'Create Date': `${changeDateFormate(exportData[i].create_date)}`
        });
    }
    return expAge;
};
export const exportExcel = (data: any) => {
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(processExport(data));
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, 'assignments');
    });
};
export const saveAsExcelFile = (buffer: any, fileName: any) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};
export const GetRoleData = () => {
    const data: any = [];
    data.push({ name: 'EDS', code: 'eds' },
        { name: 'Comp', code: 'comp' });
    return data;
}
export const GetLinkLevelData = (role:string) => {
    const data: any = [];
    if(role === 'comp'){
        data.push({ name: 'Global', code: 'global' });
    }
    else{
    data.push({ name: 'Global', code: 'global' },
        { name: 'Parent Client', code: 'parentclient' },
        { name: 'Scorecard', code: 'scorecard' });
    }
    return data;
}